// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer_footer__nDBpe {
  width: 100%;
  background: white;
  border-top: 1px solid #e5e7eb;
  color: #4b5563;
  padding: 64px 0 32px;
}

.Footer_inner__S7oOq {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Logo */
.Footer_logo__5OEGa {
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 40px;
  display: flex;
  align-items: center;
}

.Footer_logoWhite__GkH1t {
  color: #ffffff;
}

.Footer_logoGold__DzBNT {
  color: #d4af37; /* gold */
}

/* Links */
.Footer_links__ehaSY {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(7, auto);
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 32px;
}

.Footer_links__ehaSY a {
  color: #e5e7eb;
  font-size: 14px;
  text-decoration: none;
  transition: color 0.25s ease;
}

.Footer_links__ehaSY a:hover {
  color: #ffffff;
}

/* Divider */
.Footer_divider__XAill {
  width: 100%;
  height: 1px;
  background-color: rgba(229, 231, 235, 1);
  margin-bottom: 20px;
}

/* Copyright */
.Footer_copy__h3Sfv {
  font-size: 13px;
  color: #4b5563;
  text-align: center;
}
.Footer_logoContainer__R\\+miQ {
  margin-bottom: 40px;
}

/* Responsive */
@media (max-width: 1024px) {
  .Footer_links__ehaSY {
    grid-template-columns: repeat(3, auto);
    row-gap: 20px;
    justify-content: center;
  }
}

@media (max-width: 600px) {
  .Footer_logo__5OEGa {
    font-size: 36px;
  }

  .Footer_links__ehaSY {
    grid-template-columns: repeat(2, auto);
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/pages/components/Footer.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc,EAAE,SAAS;AAC3B;;AAEA,UAAU;AACV;EACE,WAAW;EACX,aAAa;EACb,sCAAsC;EACtC,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,WAAW;EACX,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,sCAAsC;IACtC,aAAa;IACb,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,sCAAsC;EACxC;AACF","sourcesContent":[".footer {\n  width: 100%;\n  background: white;\n  border-top: 1px solid #e5e7eb;\n  color: #4b5563;\n  padding: 64px 0 32px;\n}\n\n.inner {\n  max-width: 1440px;\n  margin: 0 auto;\n  padding: 0 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n/* Logo */\n.logo {\n  font-size: 48px;\n  font-weight: 700;\n  margin-bottom: 40px;\n  display: flex;\n  align-items: center;\n}\n\n.logoWhite {\n  color: #ffffff;\n}\n\n.logoGold {\n  color: #d4af37; /* gold */\n}\n\n/* Links */\n.links {\n  width: 100%;\n  display: grid;\n  grid-template-columns: repeat(7, auto);\n  justify-content: space-between;\n  gap: 24px;\n  margin-bottom: 32px;\n}\n\n.links a {\n  color: #e5e7eb;\n  font-size: 14px;\n  text-decoration: none;\n  transition: color 0.25s ease;\n}\n\n.links a:hover {\n  color: #ffffff;\n}\n\n/* Divider */\n.divider {\n  width: 100%;\n  height: 1px;\n  background-color: rgba(229, 231, 235, 1);\n  margin-bottom: 20px;\n}\n\n/* Copyright */\n.copy {\n  font-size: 13px;\n  color: #4b5563;\n  text-align: center;\n}\n.logoContainer {\n  margin-bottom: 40px;\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .links {\n    grid-template-columns: repeat(3, auto);\n    row-gap: 20px;\n    justify-content: center;\n  }\n}\n\n@media (max-width: 600px) {\n  .logo {\n    font-size: 36px;\n  }\n\n  .links {\n    grid-template-columns: repeat(2, auto);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `Footer_footer__nDBpe`,
	"inner": `Footer_inner__S7oOq`,
	"logo": `Footer_logo__5OEGa`,
	"logoWhite": `Footer_logoWhite__GkH1t`,
	"logoGold": `Footer_logoGold__DzBNT`,
	"links": `Footer_links__ehaSY`,
	"divider": `Footer_divider__XAill`,
	"copy": `Footer_copy__h3Sfv`,
	"logoContainer": `Footer_logoContainer__R+miQ`
};
export default ___CSS_LOADER_EXPORT___;
